export default {
    code: 'ms',
    htmlLang: 'ms-MY',
    ogLocale: 'ms_MY',
    selectLabel: 'BM',
    meta: {
        home: {
            title: 'Klinik Pergigian Irma Ariandi — Wear Your Smile | Klinik Pergigian Johor Bahru',
            description: 'Klinik pergigian di Johor Bahru untuk braces biasa, clear aligners, FRC dan zirconia crown & bridge. Pergigian yang baik, nasihat yang jujur, yuran yang telus.',
        },
    },
    nav: {
        home: 'Utama',
        treatments: 'Rawatan',
        teen: 'Teen Smile',
        teenBadge: 'Panduan ibu bapa',
        international: 'Pesakit Antarabangsa',
        kolum: 'Coffee With Dr. Irma',
        doctors: 'Doktor Kami',
        stories: 'Kisah Pesakit',
        contact: 'Hubungi',
        book: 'Temu janji',
        menu: 'Menu',
        close: 'Tutup',
        language: 'Bahasa',
        treatmentsMenu: [
            { slug: 'conventional-braces', title: 'Braces Biasa', desc: 'Ortodontik konvensional yang terbukti' },
            { slug: 'clear-aligners', title: 'Clear Aligners', desc: 'Pilihan ortodontik yang lebih halus' },
            { slug: 'frc', title: 'FRC', desc: 'Ganti gigi depan tanpa pembedahan besar' },
            { slug: 'zirconia-crowns-bridges', title: 'Zirconia Crown & Bridge', desc: 'Restorasi seramik yang kuat dan estetik' },
            { slug: 'aesthetic-veneers', title: 'Aesthetic Veneers & Smile Makeover', desc: 'Senyum yang direka khusus untuk anda' },
        ],
        digitalLink: { path: '/digital-dentistry', title: 'Digital Dentistry', desc: 'Teknologi di sebalik perancangan rawatan' },
        internationalMenu: [
            { path: '/international/singapore', title: 'Singapura', desc: 'Untuk pesakit dari Singapura' },
            { path: '/international/indonesia-batam', title: 'Indonesia / Batam', desc: 'Untuk pesakit dari Batam dan Indonesia' },
            { path: '/international', title: 'Sekilas pandang', desc: 'Bagaimana rawatan lintas sempitan berfungsi' },
        ],
        doctorsMenu: [
            { path: '/doctors/dr-irma-ariandi', title: 'Dr. Irma (DDS, UKM)', desc: 'Doktor gigi · Pendidik · Penulis' },
            { path: '/doctors/dr-ariandi', title: 'Dr. Ariandi (DDS, UKM)', desc: 'Doktor gigi' },
        ],
    },
    cta: {
        whatsapp: 'WhatsApp kami',
        whatsappLong: 'WhatsApp klinik',
        book: 'Temu janji',
        askIrma: 'Tanya Dr. Irma',
        explore: 'Lihat rawatan',
        email: 'E-mel kami',
    },
    journeySteps: [
        { k: '01', t: 'PERIKSA', d: 'Pemeriksaan yang teliti dan diagnosis yang betul.' },
        { k: '02', t: 'TERANGKAN', d: 'Kami terangkan apa yang kami nampak, dengan bahasa yang mudah.' },
        { k: '03', t: 'PILIHAN', d: 'Semua pilihan yang munasabah, di atas meja.' },
        { k: '04', t: 'YURAN', d: 'Yuran diterangkan sebelum rawatan, bukan selepas.' },
        { k: '05', t: 'PUTUSKAN', d: 'Anda yang putuskan. Kami yang nasihati.' },
        { k: '06', t: 'RAWAT', d: 'Rawatan mengikut rentak anda.' },
        { k: '07', t: 'SEMAK', d: 'Kami semak, laraskan dan pantau bersama anda.' },
    ],
    journeyNote: 'Setiap pesakit adalah berbeza. Laluan sebenar anda sentiasa diterangkan oleh doktor selepas pemeriksaan.',
    home: {
        hero: {
            badge: 'Klinik Pergigian Irma Ariandi · Johor Bahru',
            titleA: 'WEAR YOUR',
            titleB: 'SMILE.',
            sub: 'Rawatan pergigian yang baik. Nasihat yang jujur. Harga yang telus. Rawatan yang mesra.',
            sub2: 'Rawatan ortodontik, restoratif dan estetik pergigian di Johor Bahru — dirancang dengan teliti, dijelaskan dengan jujur.',
            chips: ['BRACES', 'CLEAR ALIGNERS', 'FRC', 'ZIRCONIA', 'VENEERS'],
            welcome: 'Menyambut pesakit dari Johor, Singapura dan Indonesia.',
            imgCaption: 'Johor Bahru, Malaysia',
            imgAlt: 'Ilustrasi: senyuman yang sihat',
        },
        marquee: ['Good dentistry', 'Pergigian yang baik', '用心的牙科', 'நல்ல பல் சிகிச்சை', 'Honest advice', 'Nasihat yang jujur', '诚实的建议', 'நேர்மையான ஆலோசனை', 'Transparent fees', 'Yuran yang telus', '透明的收费', 'வெளிப்படையான கட்டணம்', 'Human care', 'Penjagaan yang manusiawi', '人性化的关怀', 'மனிதநேயமான கவனிப்பு'],
        pathways: {
            eyebrow: 'Di mana anda mula mahu bercakap?',
            title: 'Apakah yang anda ingin ubah tentang senyuman anda?',
            sub: 'Nyatakan keadaan anda, dan kami bawa anda ke maklumat yang betul — dan perbualan yang betul.',
            items: [
                { id: 'straighter', label: 'Saya mahu gigi yang lebih lurus.', to: '/treatments/conventional-braces' },
                { id: 'discreet', label: 'Saya mahu cara yang lebih halus untuk meluruskan gigi.', to: '/treatments/clear-aligners' },
                { id: 'brighter', label: 'Saya mahu senyuman yang lebih cerah dan estetik.', to: '/treatments/aesthetic-veneers' },
                { id: 'shape', label: 'Saya mahu mengubah bentuk atau kadar bit gigi saya.', to: '/treatments/aesthetic-veneers' },
                { id: 'broken', label: 'Gigi depan saya patah atau rosak.', to: '/treatments/frc' },
                { id: 'restore', label: 'Saya perlu memulihkan gigi yang rosak.', to: '/treatments/zirconia-crowns-bridges' },
                { id: 'teen', label: 'Saya mencari braces untuk anak remaja saya.', to: '/teen-smile' },
                { id: 'sg', label: 'Saya datang dari Singapura.', to: '/international/singapore' },
                { id: 'id', label: 'Saya datang dari Indonesia.', to: '/international/indonesia-batam' },
                { id: 'unsure', label: 'Saya tidak pasti apa yang saya perlukan.', to: '/contact' },
            ],
        },
        pillars: {
            eyebrow: 'Lima tunjang kami',
            title: 'Fokus yang jelas, kerja yang teliti',
            sub: 'Kami menumpukan amalan pada lima bidang rawatan — supaya kami boleh melakukannya dengan baik, dan menerangkannya dengan jujur.',
            ctaCard: { title: 'Tidak pasti rawatan yang sesuai?', text: 'Mulakan dengan perbualan — kami bantu anda memahami pilihan anda.', cta: 'Rancang konsultasi' },
        },
        why: {
            eyebrow: 'Kenapa pesakit memilih kami',
            title: 'Kenapa pesakit memilih — dan mengingati — klinik ini',
            items: [
                { title: 'Nasihat yang jujur', text: 'Jika rawatan tidak diperlukan, kami beritahu. Jika ada pilihan yang lebih wajar, kami sebutkan.' },
                { title: 'Perbincangan rawatan yang telus', text: 'Pilihan dan yuran diterangkan dengan jelas sebelum rawatan bermula. Tiada kejutan.' },
                { title: 'Penjagaan yang manusiawi', text: 'Pesakit mengingati doktor yang mendengar — dan doktor yang layak dipercayai.' },
                { title: 'Pengalaman klinikal', text: 'Pemeriksaan yang teliti dan rawatan yang dilakukan dengan berhati-hati.' },
                { title: 'Pergigian moden', text: 'Teknologi digital menyokong diagnosis dan perancangan, di mana sesuai secara klinikal.' },
            ],
        },
        doctors: {
            eyebrow: 'Kenali doktor anda',
            title: 'Dr. Irma & Dr. Ariandi',
            sub: 'Dr. Irma yang juga seorang pencipta lagu, penulis buku dan juga pernah menulis untuk segmen kesihatan akhbar Utusan Malaysia. Dr. Irma sekarang berkongsi ilmu pergigian di ruangan ini. Jom sambil santai baca segmen "Coffee With Dr. Irma" bercerita tentang gigi, gusi dan mungkin sesekali tentang kehidupan.',
            irmaLine: 'Doktor gigi · Pendidik pergigian · Penulis — pernah menulis untuk segmen kesihatan akhbar Utusan Malaysia.',
            ariandiLine: 'Doktor gigi',
            cta: 'Kenali kami',
        },
        teen: {
            eyebrow: 'Teen Smile',
            title: 'Panduan ibu bapa tentang braces remaja',
            text: 'Untuk ibu bapa di Johor Bahru yang mahu jawapan yang jujur — bila masa yang sesuai, apa yang berlaku pada penilaian pertama, dan bagaimana memilih dengan tenang.',
            points: [
                'Penilaian pertama tanpa tekanan',
                'Braces biasa vs clear aligners untuk remaja',
                'Gigih sekolah, sukan dan kebersihan semasa rawatan',
            ],
            cta: 'Baca panduan ibu bapa',
        },
        intl: {
            eyebrow: 'Pesakit antarabangsa',
            title: 'Rawatan lintas sempadan, dirancang dengan baik',
            sg: { title: 'Dari Singapura', text: 'Rawatan clear aligner di Johor Bahru, dengan struktur review yang dirancang supaya kunjungan boleh digabungkan dengan lawatan ke JB.' },
            id: { title: 'Dari Indonesia / Batam', text: 'Rawatan clear aligner dan restoratif terpilih di Johor Bahru, dengan panduan perjalanan dan komunikasi yang mudah.' },
            aligner: 'Clear aligners ialah rawatan utama pesakit antarabangsa kami — review klinikal dirancang kira-kira setiap 3 bulan, di mana sesuai secara klinikal, supaya lawatan boleh digabungkan dengan kunjungan ke Johor Bahru.',
            note: 'Tertakluk kepada keperluan klinikal individu, pelan rawatan, terma klinik/pembekal dan keperluan penghantaran yang berkenaan.',
            cta: 'Pesakit antarabangsa',
        },
        digital: {
            eyebrow: 'Teknologi kami',
            title: 'WE EMBRACE DIGITAL DENTISTRY',
            p1: 'Pergigian moden bukan hanya tentang apa yang kami lakukan — tetapi juga bagaimana kami merancang.',
            p2: 'Di klinik kami, teknologi digital menyokong bidang terpilih diagnosis, perancangan rawatan dan aliran kerja restoratif atau estetik. Pengimbas intraoral membolehkan kami merakam representasi digital gigi tanpa bergantung sepenuhnya pada kesan konvensional, di mana sesuai secara klinikal.',
            note: 'Teknologi menyokong pertimbangan klinikal — bukan menggantikannya.',
            cta: 'JELAJAH PERGIGIAN DIGITAL',
        },
        veneers: {
            eyebrow: 'Aesthetic Veneers & Smile Makeover',
            title: 'Senyum yang direka khusus untuk anda',
            text: 'Untuk pesakit yang ingin menambah baik warna, bentuk, kadar bit, keseragaman atau rupa keseluruhan senyuman — veneer estetik mungkin salah satu pilihan rawatan selepas penilaian pergigian yang betul. Setiap senyuman berbeza.',
            artist: { title: 'THE ARTIST SMILE', text: 'Untuk pesakit yang menggemari estetik putih yang cerah, kilat dan sedia kamera. Sesetengah pesakit lebih suka warna yang sangat semula jadi; yang lain lebih terang dan bergaya — matlamat estetik dibincangkan semasa perancangan senyum.' },
            cta: 'RANCANG KONSULTASI SENYUM',
            ctaWa: 'TANYA TENTANG VENEER',
        },
        kolum: {
            eyebrow: 'Coffee With Dr. Irma',
            title: 'Gigi, gusi dan mungkin sesekali tentang kehidupan',
            sub: 'Dr. Irma Ariandi berkongsi ilmu pergigian sambil santai — gigi, gusi dan mungkin sesekali tentang kehidupan.',
            empty: 'Artikel pertama dalam bahasa ini sedang disediakan. Sementara itu, ini artikel daripada klinik kami.',
            cta: 'Baca Coffee With Dr. Irma',
        },
        remember: {
            eyebrow: 'Apa yang pesakit ingat',
            title: 'Apa yang pesakit ingat',
            sub: 'Perkataan sebenar daripada pesakit yang disahkan — dikongsi dengan kebenaran, tanpa nama. Diterbitkan seadanya, dalam bahasa asalnya.',
            themes: ['Yuran yang telus', 'Nasihat yang jujur', 'Doktor yang mesra', 'Yakin dari segi klinikal', 'Penjagaan yang manusiawi'],
            verifiedLabel: 'Pesakit disahkan',
        },
        journey: {
            eyebrow: 'Falsafah kami',
            title: 'Fahami dahulu. Putuskan kemudian.',
        },
        nervous: {
            title: 'Gementar untuk ke doktor gigi?',
            text: 'Beritahu kami. Kami faham. Ramai pesakit kami memberitahu bahawa mereka takut — kami ambil masa untuk menerangkan, dan anda yang tentukan rentaknya. Tiada kuliah, tiada tekanan.',
            cta: 'Beritahu kami di WhatsApp',
        },
        location: {
            eyebrow: 'Jumpa kami',
            title: 'Temui kami di Johor Bahru',
            addressLabel: 'Alamat',
            addressValue: '1-24 & 1-25, Aras 1, Plaza Larkin, Jalan Garuda, 80350 Johor Bahru, Johor, Malaysia',
            hoursLabel: 'Waktu operasi',
            hoursValue: 'Ahad–Khamis: 10:00 pagi – 6:00 petang (rehat tengah hari 1:00 – 2:00 petang) · Sabtu: 9:00 pagi – 12:30 tengah hari · Jumaat & cuti umum: tutup · Melalui temu janji sahaja',
            mapNote: 'Klinik kami terletak di Aras 1, Plaza Larkin (lihat bangunan di atas).',
            whatsappLabel: 'WhatsApp',
            emailLabel: 'E-mel',
        },
        finalCta: {
            title: 'WEAR YOUR SMILE.',
            sub: 'Mula dengan perbualan. Beritahu kami secara ringkas apa yang mengganggu anda — kami pandu anda ke langkah seterusnya yang sewajarnya.',
            primary: 'WhatsApp klinik',
            secondary: 'Temu janji',
        },
    },
    treatLabels: {
        who: 'Siapa yang mungkin mempertimbangkan rawatan ini',
        problem: 'Masalah yang ditangani',
        assessment: 'Bagaimana penilaian dilakukan',
        options: 'Pilihan rawatan',
        journey: 'Perjalanan rawatan',
        know: 'Apa yang pesakit patut tahu',
        followup: 'Pertimbangan susulan biasa',
        faq: 'Soalan yang kerap ditanya',
        doctors: 'Doktor anda',
        articles: 'Bacaan berkaitan',
        teenNoteLabel: 'Untuk remaja — apa yang ibu bapa patut tahu',
        intlNoteLabel: 'Pesakit antarabangsa',
        ctaTitle: 'Masih mempertimbangkan?',
        ctaText: 'Hubungi klinik. Kami akan bantu anda memahami sama ada rawatan ini sesuai — dengan jujur.',
        digital: 'Sokongan pergigian digital',
    },
    teen: {
        metaTitle: 'Teen Smile: Panduan Ibu Bapa tentang Braces Remaja | Klinik Pergigian Irma Ariandi',
        metaDesc: 'Panduan jujur untuk ibu bapa di Johor Bahru: umur sesuai mula braces, penilaian pertama, braces vs clear aligners, dan kehidupan sekolah semasa rawatan.',
        title: 'Teen Smile',
        subtitle: 'Panduan ibu bapa',
        heroText: 'Anak anda tidak minta braces itu. Anda yang sedang membuat kajian — dan itu langkah yang betul. Halaman ini disediakan untuk ibu bapa di Johor Bahru yang mahu memahami pilihan anak remaja mereka dengan tenang dan jujur.',
        ctaTitle: 'Ada soalan tentang gigi anak anda?',
        ctaText: 'WhatsApp klinik kami. Nyatakan umur anak anda dan kebimbangan utama anda — kami akan cadangkan langkah seterusnya yang sewajarnya.',
    },
    international: {
        metaTitle: 'Pesakit Antarabangsa — Singapura & Indonesia | Klinik Pergigian Irma Ariandi',
        metaDesc: 'Rawatan pergigian di Johor Bahru untuk pesakit dari Singapura, Batam dan Indonesia. Perjalanan rawatan, struktur review dan perancangan temu janji.',
        title: 'Pesakit Antarabangsa',
        subtitle: 'Singapura · Indonesia / Batam',
        heroText: 'Kami menerima pesakit yang datang dari Singapura dan Indonesia — terutamanya untuk rawatan clear aligner dan restoratif terpilih. Halaman ini menerangkan bagaimana ia berfungsi, sebelum anda menghubungi kami.',
    },
    kolum: {
        tagline: 'Dental Health · Smiles · Modern Dentistry',
        metaTitle: 'Coffee With Dr. Irma | Klinik Pergigian Irma Ariandi',
        metaDesc: 'Ruangan "Coffee With Dr. Irma" — ilmu pergigian dikongsi oleh Dr. Irma Ariandi, doktor gigi di Johor Bahru, sambil santai.',
        title: 'Coffee With Dr. Irma',
        sub: 'Ruangan santai oleh Dr. Irma Ariandi, DDS (UKM) — bercerita tentang gigi, gusi dan mungkin sesekali tentang kehidupan.',
        all: 'Semua',
        by: 'oleh',
        minRead: 'min bacaan',
        published: 'Diterbitkan',
        updated: 'Dikemas kini',
        empty: 'Kolum dalam bahasa ini sedang disediakan. Sementara itu, baca kolum dalam bahasa lain di bawah.',
        langOf: 'Bahasa',
        back: 'Semua artikel',
        stillUnsure: {
            title: 'MASIH TIDAK PASTI?',
            text: 'Tanya Dr. Irma. Beritahu kami secara ringkas apa yang mengganggu anda, dan pasukan klinik kami akan pandu anda ke langkah seterusnya yang sewajarnya.',
            cta: 'WhatsApp klinik',
            note: 'Komunikasi WhatsApp membantu klinik mengarahkan anda — ia bukan diagnosis.',
        },
        relatedTreatment: 'Rawatan berkaitan',
        authorLine: 'Ditulis oleh Dr. Irma (DDS, UKM), Klinik Pergigian Irma Ariandi.',
        sampleNote: 'Kolum contoh — kandungan akan disemak dan disahkan oleh klinik sebelum pelancaran rasmi.',
    },
    doctors: {
        metaTitleIrma: 'Dr. Irma (DDS, UKM) — Doktor Gigi, Pendidik & Penulis | Johor Bahru',
        metaDescIrma: 'Profil Dr. Irma Ariandi, DDS (UKM), doktor gigi di Johor Bahru, pendidik pergigian dan bekas kolumnis kesihatan Utusan Malaysia.',
        metaTitleAriandi: 'Dr. Ariandi (DDS, UKM) — Doktor Gigi | Klinik Pergigian Irma Ariandi, Johor Bahru',
        metaDescAriandi: 'Profil Dr. Ariandi, DDS (UKM), doktor gigi di Klinik Pergigian Irma Ariandi, Johor Bahru.',
        profile: 'Profil doktor',
        quals: 'Kelayakan',
        interests: 'Minat rawatan',
        philosophy: 'Falsafah rawatan',
        articlesBy: 'Kolum oleh',
        pendingBio: '[BIO DOKTOR AKAN DIPASTIKAN]',
        pendingInterests: '[MINAT RAWATAN AKAN DIPASTIKAN]',
        pendingPhilosophy: '[FALSAFAH RAWATAN AKAN DIPASTIKAN]',
        cta: 'Temu janji dengan',
        irmaRoles: 'Doktor gigi · Pendidik pergigian · Penulis',
        irmaColumnist: 'Dr. Irma pernah menulis untuk segmen kesihatan akhbar Utusan Malaysia. Kini beliau berkongsi ilmu pergigian di ruangan "Coffee With Dr. Irma" — sambil santai, bercerita tentang gigi, gusi dan mungkin sesekali tentang kehidupan.',
        ariandiRoles: 'Doktor gigi',
    },
    stories: {
        metaTitle: 'Apa yang Pesakit Ingat | Klinik Pergigian Irma Ariandi',
        metaDesc: 'Ulasan dan kisah pesakit Klinik Pergigian Irma Ariandi di Johor Bahru — diterbitkan hanya selepas disahkan dan dengan kebenaran.',
        title: 'Apa yang pesakit ingat',
        sub: 'Perkataan sebenar daripada pesakit yang disahkan — dikongsi dengan kebenaran, tanpa nama. Diterbitkan seadanya, dalam bahasa asalnya. Kami tidak mengedit atau menghiasinya.',
        themesTitle: 'Tema yang pesakit sebutkan kepada kami',
        verifiedLabel: 'Pesakit disahkan',
        caseTitle: 'Kisah kes (Case stories)',
        caseNote: 'Kisah kes sebenar — dengan kebimbangan pesakit, pilihan yang dibincangkan dan perjalanan rawatan — akan diterbitkan hanya dengan kebenaran pesakit yang bertulis dan pematuhan profesional. Struktur sedang disediakan sekarang.',
        caseSlot: '[KISAH KES SEBENAR UNTUK DIMASUKKAN]',
    },
    about: {
        metaTitle: 'Tentang Klinik | Klinik Pergigian Irma Ariandi, Johor Bahru',
        metaDesc: 'Klinik Pergigian Irma Ariandi di Johor Bahru — pergigian yang baik, nasihat yang jujur, yuran yang telus, penjagaan yang berperikemanusiaan.',
        title: 'Tentang klinik',
        intro: 'Klinik Pergigian Irma Ariandi ialah klinik pergigian di Johor Bahru, Johor, Malaysia. Kami memberi tumpuan kepada lima bidang rawatan — braces biasa, clear aligners, FRC, zirconia crown & bridge dan veneer estetik & smile makeover — dengan satu janji yang sama.',
        promisesTitle: 'Janji kami',
        promises: [
            { t: 'Pergigian yang baik', d: 'Kerja yang teliti, dilakukan dengan sebab yang jelas.' },
            { t: 'Nasihat yang jujur', d: 'Apa yang kami katakan adalah apa yang kami akan lakukan — atau tidak lakukan.' },
            { t: 'Yuran yang telus', d: 'Diterangkan sebelum rawatan, dengan rincian yang jelas.' },
            { t: 'Penjagaan yang berperikemanusiaan', d: 'Anda bukan nombor giliran. Anda pesakit yang kami kenali.' },
        ],
        philosophyTitle: 'Falsafah rawatan kami',
        photoSlot: '[FOTO KLINIK SEBENAR UNTUK DIMASUKKAN]',
    },
    contact: {
        metaTitle: 'Hubungi / Temu Janji | Klinik Pergigian Irma Ariandi, Johor Bahru',
        metaDesc: 'Hubungi Klinik Pergigian Irma Ariandi di Johor Bahru melalui WhatsApp 011-3306 5735 atau e-mel. Borang temu janji yang mudah — tanpa perlu mendaftar akaun.',
        title: 'Hubungi kami',
        sub: 'Langkah paling pantas ialah WhatsApp. Jika anda lebih selesa dengan borang, kami sedia membantu melaluinya juga.',
        whatsappTitle: 'WhatsApp (paling pantas)',
        emailTitle: 'E-mel / temu janji',
        addressTitle: 'Alamat',
        addressValue: '1-24 & 1-25, Aras 1, Plaza Larkin, Jalan Garuda, 80350 Johor Bahru, Johor, Malaysia',
        hoursTitle: 'Waktu operasi',
        hoursValue: 'Ahad–Khamis: 10:00 pagi – 6:00 petang (rehat tengah hari 1:00 – 2:00 petang) · Sabtu: 9:00 pagi – 12:30 tengah hari · Jumaat & cuti umum: tutup · Melalui temu janji sahaja',
        formTitle: 'Borang pertanyaan ringkas',
        form: {
            name: 'Nama',
            namePh: 'Nama anda',
            method: 'Kaedah hubungan yang anda mahu',
            methodOptions: ['WhatsApp', 'Panggilan telefon', 'E-mel'],
            treatment: 'Rawatan yang diminati',
            treatmentOptions: ['Braces biasa', 'Clear aligners', 'FRC', 'Zirconia crown & bridge', 'Veneer estetik', 'Belum pasti lagi', 'Lain-lain'],
            phoneLabel: 'Nombor WhatsApp / Telefon',
            phonePh: '12-345 6789',
            dateLabel: 'Tarikh temu janji pilihan',
            timeLabel: 'Masa pilihan',
            timeOptions: ['Pagi (10 pagi – 1 tengah hari)', 'Tengah hari (1 – 3 petang)', 'Petang (3 – 6 petang)'],
            successTitle: 'Permintaan temu janji diterima',
            successBody: 'Pasukan klinik akan menyemak kekosongan dan menghubungi anda untuk pengesahan. Maklumat ini juga sudah dikongsi dengan Aira — anda boleh berbual dengannya tanpa mengulang semula.',
            successAira: 'Teruskan dengan Aira',
            successWa: 'Teruskan ke WhatsApp',
            time: 'Masa temu janji yang anda mahukan',
            timePh: 'cth: Hujung minggu ini, petang',
            country: 'Anda berada di',
            countryOptions: ['Malaysia', 'Singapura', 'Indonesia', 'Lain-lain'],
            message: 'Mesej ringkas',
            messagePh: 'Beritahu kami ringkasnya apa yang mengganggu anda',
            submit: 'Hantar pertanyaan',
            success: 'Terima kasih. Kami akan menghubungi anda dalam masa terdekat.',
            error: 'Maaf, penghantaran gagal. Sila cuba WhatsApp kami terus.',
            consent: 'Dengan menghantar borang ini, anda bersetuju supaya kami menghubungi anda berkenaan pertanyaan anda. Butiran anda hanya digunakan untuk tujuan ini.',
        },
    },
    privacy: {
        metaTitle: 'Polisi Privasi | Klinik Pergigian Irma Ariandi',
        metaDesc: 'Polisi privasi Klinik Pergigian Irma Ariandi — bagaimana maklumat pertanyaan anda dikumpul, digunakan dan dilindungi.',
        title: 'Polisi Privasi',
        updated: 'Versi 1.0 — [TARIKH AKAN DIPASTIKAN]',
        sections: [
            { h: 'Apa yang kami kumpul', p: 'Kami hanya mengumpul maklumat yang anda berikan melalui borang pertanyaan atau mesej WhatsApp — nama, kaedah hubungan dan ringkasan pertanyaan anda. Kami tidak meminta sejarah perubatan terperinci melalui borang pemasaran.' },
            { h: 'Bagaimana kami gunakannya', p: 'Maklumat anda digunakan semata-mata untuk menjawab pertanyaan dan menguruskan temu janji. Ia tidak dijual atau dikongsi untuk pemasaran pihak ketiga.' },
            { h: 'Kuki dan analitik', p: 'Laman web ini boleh menggunakan alat analitik untuk memahami penggunaan laman secara agregat. Analitik tidak digunakan untuk mengenali anda secara peribadi.' },
            { h: 'Penyimpanan dan keselamatan', p: 'Pertanyaan disimpan secara selamat dan diakses hanya oleh pasukan klinik untuk tujuan menjawab pertanyaan anda.' },
            { h: 'Hak anda', p: 'Untuk pertanyaan tentang data anda, hubungi kami di klinikpergigianirmaariandi@gmail.com.' },
        ],
    },
    disclaimer: {
        metaTitle: 'Penafian Laman Web & Perubatan | Klinik Pergigian Irma Ariandi',
        metaDesc: 'Penafian perubatan laman web Klinik Pergigian Irma Ariandi — maklumat pendidikan, bukan pengganti pemeriksaan klinikal.',
        title: 'Penafian Laman Web & Perubatan',
        updated: 'Versi 1.0 — [TARIKH AKAN DIPASTIKAN]',
        sections: [
            { h: 'Maklumat pendidikan', p: 'Kandungan di laman web ini adalah untuk tujuan pendidikan dan maklumat umum. Ia bukan pengganti pemeriksaan klinikal, diagnosis atau pelan rawatan individu.' },
            { h: 'Penilaian individu diperlukan', p: 'Kesesuaian rawatan, tempoh, bilangan lawatan dan hasil berbeza mengikut pesakit. Sebarang keputusan rawatan memerlukan penilaian klinikal oleh doktor gigi.' },
            { h: 'Bukan diagnosis melalui WhatsApp', p: 'Komunikasi melalui WhatsApp membantu klinik mengarahkan anda ke langkah yang sewajarnya. Ia bukan diagnosis dan tidak menggantikan pemeriksaan.' },
            { h: 'Tiada jaminan', p: 'Kami tidak membuat tuntutan jaminan hasil rawatan. Apa yang kami janjikan ialah penjelasan yang jujur, yuran yang telus dan penjagaan yang manusiawi.' },
        ],
    },
    notFound: {
        title: 'Halaman ini tiada',
        text: 'Pautan mungkin salah atau halaman sedang dibina. Mari kembali ke permulaan.',
        cta: 'Kembali ke utama',
    },
    footer: {
        about: 'Klinik pergigian di Johor Bahru. Braces biasa, clear aligners, FRC, zirconia crown & bridge, veneer estetik & smile makeover.',
        quickLinks: 'Pautan pantas',
        treatments: 'Rawatan',
        international: 'Pesakit antarabangsa',
        kolum: 'Coffee With Dr. Irma',
        doctors: 'Doktor',
        contact: 'Hubungi',
        privacy: 'Polisi Privasi',
        disclaimer: 'Penafian Laman Web & Perubatan',
        whatsapp: 'WhatsApp',
        email: 'E-mel',
        address: '1-24 & 1-25, Aras 1, Plaza Larkin, Jalan Garuda, 80350 Johor Bahru, Johor, Malaysia',
        addressSlot: '',
        rights: 'Klinik Pergigian Irma Ariandi. Hak cipta terpelihara.',
        disclaimerLine: 'Maklumat di laman web ini bersifat pendidikan dan bukan pengganti pemeriksaan klinikal.',
    },
};
